// The signed-in person's photo in a header, in place of "Log in".
// No photo (or it fails to load) shows a person icon rather than a blank circle.
import React, { useEffect, useState } from 'react';
import { User } from 'lucide-react';
import supabase from '../services/supabase';

const NavProfileButton = ({ userId, onClick, size = 36, className = '' }) => {
  const [photo, setPhoto] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setPhoto(null);
    setFailed(false);
    if (!userId) return undefined;
    supabase
      .from('users')
      .select('profile_photo_cdn_url, profile_photo_direct_url')
      .eq('id', userId)
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled) setPhoto(data?.profile_photo_cdn_url || data?.profile_photo_direct_url || null);
      });
    return () => { cancelled = true; };
  }, [userId]);

  const face = photo && !failed
    ? <img src={photo} alt="" onError={() => setFailed(true)} />
    : <User size={Math.round(size * 0.5)} strokeWidth={2.2} />;

  // Without onClick it's just the picture, for use inside a row that is
  // already a button.
  if (!onClick) {
    return (
      <span className={`nav-profile-btn ${className}`} aria-hidden="true" style={{ width: size, height: size }}>
        {face}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={`nav-profile-btn ${className}`}
      onClick={onClick}
      aria-label="Your dashboard"
      title="Your dashboard"
      style={{ width: size, height: size }}
    >
      {face}
    </button>
  );
};

export default NavProfileButton;
